<template>
<div class="chapter">
<div class="inner_page">
<p class="firstcenter"> </p>
<p class="firstcenter">For Breck<br/>
  Romans 15:5-6</p>
<p class="firstcenter" xmlns:xml="http://www.w3.org/XML/1998/namespace"><img alt="" src="Images/8429_DED.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?65d04de8